import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, {
        email,
        redirectTo: `${window.location.origin}/reset-password`,
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-sand-50">
      <div className="hidden lg:flex flex-col justify-center px-16 bg-terra-400/10 border-r border-sand-200 w-2/5 shrink-0">
        <p className="font-heading text-4xl font-bold text-ink-900 mb-4 leading-tight">
          Reset your password
        </p>
        <p className="text-base text-ink-400 leading-relaxed">
          We'll send a secure link to your email so you can set a new password.
        </p>
      </div>

      <div className="flex-1 flex items-center justify-center px-4 sm:px-8 py-12">
        <div className="w-full max-w-sm">
          {submitted ? (
            <div className="text-center">
              <div className="w-12 h-12 rounded-full bg-terra-400/10 flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-terra-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </div>
              <p className="font-heading text-xl font-semibold text-ink-900 mb-2">Check your email</p>
              <p className="text-sm text-ink-400 leading-relaxed mb-6">
                If an account exists for <span className="text-ink-700 font-medium">{email}</span>, you'll receive a reset link shortly.
              </p>
              <Link to="/login" className="text-sm text-terra-400 font-medium hover:text-terra-500 transition-colors">
                Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <p className="font-heading text-2xl font-semibold text-ink-900 mb-1">Forgot password?</p>
              <p className="text-sm text-ink-400 mb-8">Enter your email and we'll send you a reset link.</p>

              {error && (
                <div className="mb-4 px-4 py-3 bg-uae-red/10 border border-uae-red/20 rounded-lg text-sm text-uae-red">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <Input
                  id="email"
                  label="Email"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  required
                />
                <Button type="submit" variant="primary" loading={loading} className="w-full justify-center mt-2">
                  Send reset link
                </Button>
              </form>

              <p className="text-sm text-ink-400 mt-6 text-center">
                Remember your password?{' '}
                <Link to="/login" className="text-terra-400 font-medium hover:text-terra-500 transition-colors">
                  Sign in
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
